export default "__VITE_ASSET__25c64033__"